function inline(text) {
  const parts = text.split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g);
  return parts.map((p, i) => {
    if (p.startsWith("**")) return <strong key={i} className="text-white font-semibold">{p.slice(2, -2)}</strong>;
    if (p.startsWith("*") && p.length > 2) return <em key={i} className="text-slate-400">{p.slice(1, -1)}</em>;
    return p;
  });
}

export default function Markdown({ text, className = "" }) {
  const blocks = [];
  let list = null;
  const flush = () => {
    if (list) blocks.push(<ul key={blocks.length} className="my-3 space-y-1.5 pl-1">{list}</ul>);
    list = null;
  };
  text.split("\n").forEach((raw, i) => {
    const line = raw.trimEnd();
    if (/^\s*[-*•]\s+/.test(line)) {
      list = list || [];
      list.push(
        <li key={i} className="flex gap-3 leading-relaxed">
          <span className="mt-[9px] h-1 w-1 shrink-0 rounded-full bg-gold/80" aria-hidden="true" />
          <span>{inline(line.replace(/^\s*[-*•]\s+/, ""))}</span>
        </li>
      );
      return;
    }
    flush();
    if (/^#{1,3}\s/.test(line)) {
      blocks.push(<h4 key={i} className="mt-5 mb-2 font-mono text-[11px] uppercase tracking-[0.25em] text-gold first:mt-0">{line.replace(/^#+\s/, "")}</h4>);
    } else if (/^\d+\.\s/.test(line)) {
      blocks.push(<p key={i} className="my-1.5 leading-relaxed">{inline(line)}</p>);
    } else if (line.trim()) {
      blocks.push(<p key={i} className="my-2 leading-relaxed first:mt-0 last:mb-0">{inline(line)}</p>);
    }
  });
  flush();
  return <div className={className}>{blocks}</div>;
}
